import { DateTransform } from '@/shared/utilities/class-validator-extends';
import { Transform, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { Attachment } from './attachment';
import type { Message } from './message';
import { MessageContentType } from './message-content-type';

export class Reaction {
  @IsUUID()
  userId?: string;

  @IsOptional()
  @IsString()
  emoji?: string | null | undefined;

  @Transform(DateTransform.toClass, { toClassOnly: true })
  createdAt?: Dayjs;
}

export class ReceiveMessage {
  @IsOptional()
  @IsArray()
  @Type(() => Attachment)
  attachments: Attachment[] | null | undefined;

  @IsOptional()
  @IsString()
  content: string | null | undefined;

  @IsOptional()
  @IsUUID()
  conversationId?: string;

  @IsOptional()
  @Transform(DateTransform.toClass, { toClassOnly: true })
  editedAt: Dayjs | null | undefined;

  @IsUUID()
  id?: string;

  @IsOptional()
  @IsBoolean()
  isDeleted?: boolean | null | undefined;

  @IsOptional()
  @IsBoolean()
  isEdited: boolean | null | undefined;

  @IsOptional()
  @IsArray()
  @Type(() => Attachment)
  legacyAttachments: Attachment[] | null | undefined;

  @IsUUID()
  messageId?: string;

  @IsOptional()
  @IsEnum(MessageContentType)
  messageType?: MessageContentType | null | undefined;

  @IsOptional()
  @IsString()
  metadata: string | null | undefined;

  @IsOptional()
  @IsUUID()
  originalMessageId: string | null | undefined;

  @IsOptional()
  @IsUUID()
  parentMessageId: string | null | undefined;

  @IsOptional()
  @IsArray()
  @Type(() => Reaction)
  reactions: Reaction[] | null | undefined;

  @IsOptional()
  @IsString()
  senderAvatar: string | null | undefined;

  @IsUUID()
  senderId?: string;

  @IsOptional()
  @IsString()
  senderName: string | null | undefined;

  @IsOptional()
  @Transform(DateTransform.toClass, { toClassOnly: true })
  sentAt: Dayjs | null | undefined;

  @IsOptional()
  @Transform(DateTransform.toClass, { toClassOnly: true })
  timestamp: Dayjs | null | undefined;

  @IsOptional()
  @IsString()
  bucketId: string | null | undefined;

  constructor(init?: Partial<ReceiveMessage>) {
    Object.assign(this, init);
  }

  public toMessage() {
    return {
      messageId: this.messageId || '',
      bucketId: this.bucketId || null,
      conversationId: this.conversationId || '',
      senderId: this.senderId || '',
      senderName: this.senderName || '',
      content: this.content || '',
      contentType: this.messageType || MessageContentType.TEXT,
      parentMessageId: this.parentMessageId || null,
      originalMessageId: this.originalMessageId || null,
      isRevoked: this.isDeleted || false,
      sentAt: dayjs(this.sentAt) || null,
      structuredAttachments: this.attachments || null
    } as Message;
  }
}
